import React, { useMemo, useState } from 'react';
import Header from './Header';
import { Link, useNavigate } from 'react-router-dom';
import BaseUrl from '../BaseUrl';
import axios from 'axios';
import swal from 'sweetalert';
import Footer from './Footer';
import './style.css';

const bubbles = [
  { size: 240, left: '8%', top: '8%', opacity: 0.12, blur: 50, dur: 30, delay: -6 },
  { size: 160, left: '76%', top: '18%', opacity: 0.11, blur: 42, dur: 28, delay: -10 },
  { size: 200, left: '14%', top: '48%', opacity: 0.09, blur: 46, dur: 34, delay: -16 },
  { size: 130, left: '84%', top: '58%', opacity: 0.1, blur: 36, dur: 26, delay: -12 },
];

const dots = [
  { s: 3, l: '22%', t: '32%', o: 0.11, d: 30, dl: -8 },
  { s: 2, l: '68%', t: '42%', o: 0.1, d: 32, dl: -12 },
  { s: 3, l: '48%', t: '78%', o: 0.09, d: 36, dl: -20 },
];

const PASSWORD_LENGTH_MESSAGE = 'Password must be at least 6 characters';
const NAME_INVALID_MESSAGE = 'Only letters, spaces, hyphens, and apostrophes are allowed';
const nameRegex = /^[A-Za-z][A-Za-z\s'-]*$/;

const sanitizeName = (value) => value.replace(/[^A-Za-z\s'-]/g, '');

function EyeIcon({ open }) {
  if (open) {
    return (
      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
        <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
        <circle cx="12" cy="12" r="3" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" />
      <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
      <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
      <line x1="2" x2="22" y1="2" y2="22" />
    </svg>
  );
}

export default function SignUp() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [cPassword, setCPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const [errors, setErrors] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    cPassword: '',
  });

  const primaryGradient = useMemo(
    () => ({
      backgroundImage: 'linear-gradient(90deg, #00C6FF 0%, #009BFF 40%, #0072FF 100%)',
    }),
    []
  );

  const handleValidation = () => {
    let isValid = true;
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    const trimmedFirstName = firstName.trim();
    const trimmedLastName = lastName.trim();

    if (trimmedFirstName === '') {
      setErrors((prevErrors) => ({ ...prevErrors, firstName: 'First name is required' }));
      isValid = false;
    } else if (!nameRegex.test(trimmedFirstName)) {
      setErrors((prevErrors) => ({ ...prevErrors, firstName: NAME_INVALID_MESSAGE }));
      isValid = false;
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, firstName: '' }));
    }

    if (trimmedLastName === '') {
      setErrors((prevErrors) => ({ ...prevErrors, lastName: 'Last name is required' }));
      isValid = false;
    } else if (!nameRegex.test(trimmedLastName)) {
      setErrors((prevErrors) => ({ ...prevErrors, lastName: NAME_INVALID_MESSAGE }));
      isValid = false;
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, lastName: '' }));
    }

    if (!emailRegex.test(email)) {
      setErrors((prevErrors) => ({ ...prevErrors, email: 'Invalid email address' }));
      isValid = false;
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, email: '' }));
    }

    if (password.length < 6) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        password: PASSWORD_LENGTH_MESSAGE,
      }));
      isValid = false;
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, password: '' }));
    }

    if (cPassword.length < 6) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        cPassword: PASSWORD_LENGTH_MESSAGE,
      }));
      isValid = false;
    } else if (cPassword !== password) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        cPassword: 'Passwords do not match',
      }));
      isValid = false;
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, cPassword: '' }));
    }

    return isValid;
  };

  const userSignUp = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (handleValidation()) {
      const url = BaseUrl() + 'api/user/register_web';
      const data = {
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        email: email,
        password: password,
      };

      try {
        const response = await axios.post(url, data);
        console.log(response);
        if (response.status === 200) {
          localStorage.setItem('authorization', response.data.token);
          localStorage.setItem('profile', JSON.stringify(response.data.Response));
          navigate('/home', {
            state: {
              data: response.data.Response,
            },
          });
        } else {
          swal(response.data.ResponseMessage);
        }
      } catch (error) {
        swal(error.response.data.ResponseMessage);
      }
    }

    setLoading(false);
  };

  const inputRing =
    'min-h-[48px] rounded-[12px] border border-black/10 bg-white/70 py-2.5 pl-12 text-[15px] leading-snug text-slate-800 shadow-[0_1px_3px_rgba(15,23,42,0.07)] outline-none transition-all duration-200 ease-out placeholder:text-slate-500 hover:border-black/[0.16] hover:bg-white/[0.78] hover:shadow-[0_2px_6px_rgba(15,23,42,0.06)] focus:border-cyan-500 focus:bg-white focus:shadow-[0_0_0_3px_rgba(0,200,255,0.2)]';

  const fieldError = (hasErr) =>
    hasErr ? 'border-red-400/80 focus:border-red-400 focus:shadow-[0_0_0_3px_rgba(248,113,113,0.22)]' : '';

  const btnPrimary =
    'w-full rounded-full py-3.5 text-base font-bold text-white shadow-[0_14px_38px_rgba(0,114,255,0.38)] transition duration-300 hover:scale-[1.02] hover:brightness-110 hover:shadow-[0_20px_48px_rgba(0,198,255,0.42)] active:scale-[0.98] disabled:pointer-events-none disabled:opacity-60';

  return (
    <div className="relative flex min-h-screen flex-col bg-[#F4FEFF]">
      <div className="relative z-20 shrink-0">
        <Header />
      </div>

      <main className="relative flex min-h-0 flex-1 flex-col overflow-hidden">
        <div
          className="pointer-events-none absolute inset-0"
          style={{
            backgroundImage: [
              'linear-gradient(105deg, #CCF4FF 0%, #E8FBFF 28%, #FFFFFF 55%, #E6F4FF 100%)',
              'radial-gradient(640px 440px at 50% 42%, rgba(0,198,255,0.26), transparent 70%)',
              'radial-gradient(760px 460px at 12% 78%, rgba(0,114,255,0.08), transparent 74%)',
            ].join(','),
          }}
        />

        {bubbles.map((b, i) => (
          <span
            key={i}
            className="bsi-bubble pointer-events-none absolute"
            style={{
              width: b.size,
              height: b.size,
              left: b.left,
              top: b.top,
              opacity: b.opacity,
              filter: `blur(${b.blur}px)`,
              animationDuration: `${b.dur}s`,
              animationDelay: `${b.delay}s`,
            }}
          />
        ))}

        <div className="pointer-events-none absolute inset-0">
          {dots.map((p, i) => (
            <span
              key={i}
              className="bsi-cta-dot"
              style={{
                width: `${p.s}px`,
                height: `${p.s}px`,
                left: p.l,
                top: p.t,
                opacity: p.o,
                animationDuration: `${p.d}s`,
                animationDelay: `${p.dl}s`,
              }}
            />
          ))}
        </div>

        <div className="relative z-10 mx-auto flex w-full max-w-6xl flex-1 flex-col items-center justify-center px-4 py-10 sm:py-12 lg:flex-row lg:items-center lg:justify-between lg:gap-10 lg:py-14 xl:gap-14">
          <aside className="mb-10 hidden max-w-md flex-shrink-0 lg:mb-0 lg:flex lg:flex-col lg:justify-center">
            <div className="relative">
              <div className="absolute -left-8 top-1/3 h-48 w-48 rounded-full bg-cyan-300/30 blur-3xl" />
              <div className="absolute -right-8 bottom-1/4 h-40 w-40 rounded-full bg-[#0072FF]/18 blur-3xl" />
              <div className="relative rounded-[28px] border border-white/85 bg-white/55 p-8 shadow-[0_28px_90px_rgba(2,132,199,0.16)] backdrop-blur-xl">
                <div
                  className="mb-6 inline-flex h-14 w-14 items-center justify-center rounded-2xl text-white shadow-[0_14px_34px_rgba(0,114,255,0.28)]"
                  style={primaryGradient}
                >
                  <svg viewBox="0 0 24 24" className="h-7 w-7" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                    <circle cx="9" cy="7" r="4" />
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                  </svg>
                </div>
                <h2 className="text-2xl font-bold tracking-tight text-[#0F172A]">Create your account</h2>
                <p className="mt-3 text-sm leading-relaxed text-[#64748B]">
                  Join with the same soft, glass UI as our landing—focused fields and a calm signup flow.
                </p>
              </div>
            </div>
          </aside>

          <div className="relative w-full max-w-[480px] shrink-0 lg:max-w-[460px]">
            <div className="pointer-events-none absolute -inset-3 rounded-[28px] bg-gradient-to-br from-cyan-300/45 via-white/10 to-blue-400/35 opacity-90 blur-2xl" />
            <div className="pointer-events-none absolute inset-x-10 -bottom-8 h-28 rounded-full bg-cyan-400/20 blur-2xl" />
            <form
              onSubmit={userSignUp}
              className="relative rounded-[24px] border border-white/80 bg-[rgba(255,255,255,0.68)] p-8 shadow-[0_32px_100px_rgba(2,132,199,0.18)] backdrop-blur-xl sm:p-10"
            >
              <div className="mb-8 text-center lg:text-left">
                <h1 className="text-2xl font-bold tracking-tight text-[#0F172A] sm:text-[26px]">Sign Up</h1>
                <p className="mt-2 text-sm leading-relaxed text-[#64748B]">
                  A few details and you&apos;re ready to grow with Serendipity.
                </p>
              </div>

              <div className="space-y-7">
                <div className="grid gap-6 sm:grid-cols-2 sm:gap-5">
                  <div>
                    <label htmlFor="su-first" className="mb-2 block text-xs font-semibold uppercase tracking-wide text-slate-600">
                      First name
                    </label>
                    <div className="relative">
                      <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-500">
                        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4" />
                          <circle cx="12" cy="7" r="4" />
                        </svg>
                      </span>
                      <input
                        id="su-first"
                        type="text"
                        autoComplete="given-name"
                        placeholder="Jane"
                        value={firstName}
                        onChange={(e) => {
                          const sanitizedValue = sanitizeName(e.target.value);
                          setFirstName(sanitizedValue);
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            firstName: sanitizedValue === e.target.value ? '' : NAME_INVALID_MESSAGE,
                          }));
                        }}
                        className={`${inputRing} w-full pr-4 ${fieldError(errors.firstName)}`}
                      />
                    </div>
                    {errors.firstName && <p className="mt-1.5 text-sm text-red-600">{errors.firstName}</p>}
                  </div>

                  <div>
                    <label htmlFor="su-last" className="mb-2 block text-xs font-semibold uppercase tracking-wide text-slate-600">
                      Last name
                    </label>
                    <div className="relative">
                      <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-500">
                        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4" />
                          <circle cx="12" cy="7" r="4" />
                        </svg>
                      </span>
                      <input
                        id="su-last"
                        type="text"
                        autoComplete="family-name"
                        placeholder="Doe"
                        value={lastName}
                        onChange={(e) => {
                          const sanitizedValue = sanitizeName(e.target.value);
                          setLastName(sanitizedValue);
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            lastName: sanitizedValue === e.target.value ? '' : NAME_INVALID_MESSAGE,
                          }));
                        }}
                        className={`${inputRing} w-full pr-4 ${fieldError(errors.lastName)}`}
                      />
                    </div>
                    {errors.lastName && <p className="mt-1.5 text-sm text-red-600">{errors.lastName}</p>}
                  </div>
                </div>

                <div>
                  <label htmlFor="su-email" className="mb-2 block text-xs font-semibold uppercase tracking-wide text-slate-600">
                    Email
                  </label>
                  <div className="relative">
                    <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-500">
                      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                        <polyline points="22,6 12,13 2,6" />
                      </svg>
                    </span>
                    <input
                      id="su-email"
                      type="email"
                      autoComplete="email"
                      placeholder="you@company.com"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setErrors((prevErrors) => ({ ...prevErrors, email: '' }));
                      }}
                      className={`${inputRing} w-full pr-4 ${fieldError(errors.email)}`}
                    />
                  </div>
                  {errors.email && <p className="mt-1.5 text-sm text-red-600">{errors.email}</p>}
                </div>

                <div>
                  <label htmlFor="su-password" className="mb-2 block text-xs font-semibold uppercase tracking-wide text-slate-600">
                    Create password
                  </label>
                  <div className="relative">
                    <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-500">
                      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                      </svg>
                    </span>
                    <input
                      id="su-password"
                      type={showPassword ? 'text' : 'password'}
                      autoComplete="new-password"
                      placeholder="At least 6 characters"
                      value={password}
                      onChange={(e) => {
                        setPassword(e.target.value);
                        setErrors((prevErrors) => ({ ...prevErrors, password: '' }));
                      }}
                      className={`${inputRing} w-full pr-11 ${fieldError(errors.password)}`}
                    />
                    <button
                      type="button"
                      aria-label={showPassword ? 'Hide password' : 'Show password'}
                      onClick={() => setShowPassword((v) => !v)}
                      className={`absolute right-2 top-1/2 z-[1] -translate-y-1/2 rounded-lg p-1.5 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400/50 ${
                        showPassword ? 'text-cyan-600' : 'text-slate-400 hover:text-cyan-600'
                      }`}
                    >
                      <EyeIcon open={showPassword} />
                    </button>
                  </div>
                  {errors.password && <p className="mt-1.5 text-sm text-red-600">{errors.password}</p>}
                </div>

                <div>
                  <label htmlFor="su-cpassword" className="mb-2 block text-xs font-semibold uppercase tracking-wide text-slate-600">
                    Confirm password
                  </label>
                  <div className="relative">
                    <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-500">
                      <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                      </svg>
                    </span>
                    <input
                      id="su-cpassword"
                      type={showConfirmPassword ? 'text' : 'password'}
                      autoComplete="new-password"
                      placeholder="Repeat your password"
                      value={cPassword}
                      onChange={(e) => {
                        setCPassword(e.target.value);
                        setErrors((prevErrors) => ({ ...prevErrors, cPassword: '' }));
                      }}
                      className={`${inputRing} w-full pr-11 ${fieldError(errors.cPassword)}`}
                    />
                    <button
                      type="button"
                      aria-label={showConfirmPassword ? 'Hide confirm password' : 'Show confirm password'}
                      onClick={() => setShowConfirmPassword((v) => !v)}
                      className={`absolute right-2 top-1/2 z-[1] -translate-y-1/2 rounded-lg p-1.5 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400/50 ${
                        showConfirmPassword ? 'text-cyan-600' : 'text-slate-400 hover:text-cyan-600'
                      }`}
                    >
                      <EyeIcon open={showConfirmPassword} />
                    </button>
                  </div>
                  {errors.cPassword && <p className="mt-1.5 text-sm text-red-600">{errors.cPassword}</p>}
                </div>

                <button type="submit" disabled={loading} style={primaryGradient} className={btnPrimary}>
                  Sign Up
                </button>
              </div>

              <p className="mt-8 text-center text-sm text-[#64748B]">
                Already have an account?{' '}
                <Link to="/login" className="font-bold text-cyan-700 underline-offset-4 transition hover:text-cyan-900 hover:underline">
                  Sign In
                </Link>
              </p>
            </form>
          </div>
        </div>
      </main>

      <div className="relative z-20 mt-auto shrink-0">
        {/* <Footer /> */}
      </div>
    </div>
  );
}
